import ConfirmAlert from "Components/Alert/ConfirmAlert";
import { useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Store } from "Reducers/interface";
import { deletePartnersAPI } from "Requests/Partners";
import { createToast } from "Utils/toastFunc";
import validatePermissions from "Utils/validatePermissions";

type Partner = {
  id: number;
  name: string;
  status: string;
  deleted_at: null | string;
};
interface PartnerListItemProps {
  partnerInfo: Partner;
}

export const PartnerListItem = ({ partnerInfo }: PartnerListItemProps) => {
  const client = useQueryClient();

  const user_permissions = useSelector(
    (state: Store) => state.User.permissions
  );

  function inactivationPartnerLayout(
    partner: Partner,
    onClose: () => void,
    submitInactivePartner: (id: number) => void
  ) {
    return (
      <div className="custom-ui">
        <h5 className="h5 text-gray text-light">
          Você tem certeza que deseja inativar esse parceiro ?
        </h5>
        <div className="informations-ui">
          <strong>Código: </strong>
          <p>{partner.id}</p>

          <strong>Nome: </strong>
          <p>{partner.name}</p>
        </div>
        <div className="wrapper-buttons">
          <button className="link link-danger" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="button _action"
            onClick={() => {
              submitInactivePartner(partner.id);
              onClose();
            }}
          >
            Sim
          </button>
        </div>
      </div>
    );
  }

  const handleInactivation = async (id: number) => {
    try {
      await deletePartnersAPI(id);
      client.invalidateQueries({ queryKey: ["partners-list"] });
      createToast("success", "Parceiro inativado com sucesso");
    } catch (error) {
      createToast("error", "Não foi possível inativar este parceiro");
    }
  };

  const handleActivation = async (id: number) => {
    try {
      await deletePartnersAPI(id);
      client.invalidateQueries({ queryKey: ["partners-list"] });
      createToast("success", "Parceiro ativado com sucesso");
    } catch (error) {
      createToast("error", "Não foi possível ativar este parceiro");
    }
  };

  const handleChangeStatus = (partnerInfo: Partner) => {
    return partnerInfo.deleted_at
      ? handleActivation(partnerInfo.id)
      : ConfirmAlert(partnerInfo as any, inactivationPartnerLayout, () =>
          handleInactivation(partnerInfo.id)
        );
  };

  return (
    <tr>
      <td>{partnerInfo.id}</td>
      <td>{partnerInfo.name}</td>
      <td>{partnerInfo.deleted_at ? "Inativo" : "Ativo"}</td>

      <td className="text-right table-action">
        {validatePermissions("Update Coupons", user_permissions) && (
          <Link
            to={`/editar-parceiro/${partnerInfo.id}`}
            className="button _blue _action"
            type="button"
          >
            <span className="details-text">Editar</span>
          </Link>
        )}
        {validatePermissions("Update Coupons", user_permissions) && (
          <button
            className={`button _yellow _action ${
              partnerInfo.deleted_at ? "_danger" : null
            }`}
            type="button"
            onClick={() => handleChangeStatus(partnerInfo)}
          >
            <span className="details-text">
              {partnerInfo.deleted_at ? "Ativar" : "Inativar"}
            </span>
          </button>
        )}
      </td>
    </tr>
  );
};
